/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Documents_To_RetryInputs */

const en_queue_documents_to_retry = /** @type {(inputs: Queue_Documents_To_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents to ask again`)
};

/**
* | output |
* | --- |
* | "Documents to ask again" |
*
* @param {Queue_Documents_To_RetryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_documents_to_retry = /** @type {((inputs?: Queue_Documents_To_RetryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Documents_To_RetryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_documents_to_retry(inputs)
});